
export interface IGenerateReportService {
    generateReport(fromDate: Date, toDate: Date): Promise<any>;
}

export class GenerateReportService implements IGenerateReportService {
    static $inject = ['$http'];

    constructor(private _$http: angular.IHttpService) {
    }

    // Datetime Formate in dd/mm/yyyy
    //private getFormattedDate(dateValuetobeFormatted: Date): string {
    //    var minDate = '01 - 01 - 1900';
    //    if (dateValuetobeFormatted !== undefined) {
    //        var monthValue = dateValuetobeFormatted.getMonth() + 1;
    //        var dateValue = dateValuetobeFormatted.getDate();
    //        var yearValue = dateValuetobeFormatted.getFullYear();
    //        return monthValue + "/" + dateValue + "/" + yearValue;
    //    } else { return minDate }
    //}

    private getFormattedDate(dateValuetobeFormatted: Date): string {
        var minDate = '1900-01-01';
        if (dateValuetobeFormatted !== undefined) {
            var yearValue = dateValuetobeFormatted.getFullYear();
            var monthValue = ('0' + (dateValuetobeFormatted.getMonth() + 1)).slice(-2);
            var dateValue = ('0' + dateValuetobeFormatted.getDate()).slice(-2);
            return yearValue + "-" + monthValue + "-" + dateValue;
        } else { return minDate }
    }

    generateReport(fromDate: Date, toDate: Date): Promise<any> {
        var datesRange = { 'fromDate': this.getFormattedDate(fromDate), 'toDate': this.getFormattedDate(toDate) } 
        return new Promise<any>((resolve, reject) => {
            this._$http.post(`/Request/GenerateNSSRReportExcel`,
                datesRange, {
                    data: JSON.stringify(datesRange),
                    responseType: 'arraybuffer',
                    headers: {
                        'Accept':
                            'application/pdf,application/msword,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, image/jpeg,image/gif */*'
                    }
                })
                .then(
                    (response: any) => {
                        resolve(response.data);
                    })
                .catch(
                    (response: any) => {
                        reject(response);
                    });
        });
    }
}

angular.module('deliveryCreate.app').service('generateReportService', GenerateReportService);


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/generateReport/services/generateReportService.ts
 **/